export default "__VITE_ASSET__5np1TQKl__"